<template>
  <div :class="[shareStyle]">
    <i class="icon"></i><span v-if="count !== 0" class="desc">{{ count }}</span>
  </div>
</template>

<script>
export default {
  name: 'iconshare',
  props: ['shareStyle', 'count'],
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.iconshare1{
  display: inline-block;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
  cursor: pointer;
  margin: 0 0 6px 0;
  transition: all 0.3s;
  position: relative;
  .icon{
    display: block;
    margin: 6px auto;
    width: 32px;
    height: 32px;
    background: url('../../assets/common/icon/icon-group2.png') no-repeat;
    background-position: -64px -160px;
    vertical-align: middle;
  }
  .desc{
    display: block;
    position: absolute;
    height: 14px;
    line-height: 14px;
    border-radius: 6px;
    padding: 0 4px;
    background: #b2bac2;
    color: #fff;
    left: 30px;
    top: -2px;
    font-size: 12px;
  }
  &:hover{
    .icon{
      background-position: -96px -160px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/amount/iconshare.vue